import React from "react";
import { TIME_FILTER_OPTIONS } from "../defaults";

const useTimeFilter = () => {
  // on time filter click
  const [selectedTime, setSelectedTime] = React.useState<string>(TIME_FILTER_OPTIONS[4]);
  const handleOnTimeFilterClick = (opt: string): void => setSelectedTime(opt);

  return { selectedTime, onTimeClick: handleOnTimeFilterClick };
};

export default useTimeFilter;
